import React from 'react';
import { object, string, number, array } from 'yup';
import SuccessPopUP from '../../../UserKyc/UserKYCPopUP/SuccessPopUp';
import CompanyPan from '../CompanyDetailsComponent/Kyc/CompanyPan';
import * as _ from 'lodash';
import { navigate } from 'gatsby';
let allValues = {};
export const getAllValues = () => allValues;

let mastervalidation = {
  file: { name: 'file', seachvalue: 'file' },
  imgUrl: { name: 'imgUrl', seachvalue: 'imgUrl' },
  companyName: { name: 'companyName', seachvalue: 'companyName' },
  panNumber: {
    name: 'panNumber',
    seachvalue: 'panNumber'
  },
  regisDate: { name: 'regisDate.date', seachvalue: 'regisDate.date.value' },
  regisMonth: {
    name: 'regisDate.month',
    seachvalue: 'regisDate.month.value'
  },
  regisYear: { name: 'regisDate.year', seachvalue: 'regisDate.year.value' }
};

const Steps = [
  {
    id: 'companyPan',
    component: CompanyPan,
    initialValues: {
      file: [],
      imgUrl: [],
      isGetValues: false,
      companyName: '',
      panNumber: '',
      regisDate: {
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: '',
          label: 'Year'
        }
      }
    },
    validate: values => {
      const errors = {};
      let validation = [
        mastervalidation['file'],
        mastervalidation['companyName'],
        mastervalidation['panNumber'],
        mastervalidation['regisDate'],
        mastervalidation['regisMonth'],
        mastervalidation['regisYear']
      ];
      validation.map(each => {
        if (_.get(values, each.seachvalue, true) == '') {
          errors[each.name] = 'required';
        }
      });
      if (values.isGetValues) {
        delete errors.file;
      }
      if (
        values?.regisDate?.year?.value &&
        values?.regisDate?.date?.value &&
        values?.regisDate?.month?.value
      ) {
        let userDate = `${values?.regisDate?.month?.value +
          '/' +
          values?.regisDate?.date?.value +
          '/' +
          values?.regisDate?.year?.value}`;

        const timeObj = new Date(userDate);
        const today = new Date();

        if ((timeObj && timeObj.getTime()) >= today) {
          errors['regisDate.date'] =
            'Registration Date should prior to the Current Date';
        }
      }
      return errors;
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'kycFinal',
    component: () => {
      navigate('/app/LAP/income');
      return <></>;
    }
  }
];
export default Steps;
